"use strict";
(function () {


    var _ = require('lodash'),
        TweenMax = require('gsap'),
        AbstractView = require('./abstractview');

    var gs = window.GreenSockGlobals || {},

        _timelineIn = function () {

            var tl = new gs.TimelineMax({
                    align: "start",
                    stagger: 0
                }),
                bg = document.getElementById('bg-container').querySelector('.bg:first-child'),
                wrapper = this.el.querySelector('.intro-wrapper');

            tl.set([this.el, bg], {
                display: 'block'
            });
            

            if (!document.body.classList.contains('mobile')) {
                tl.set(bg, {
                    y: 0
                });
                tl.to([this.el, wrapper], 1.5, {
                    x: 0,
                    delay: 0.25,
                    ease: Quart.easeInOut,
                });
                tl.to(bg, 1, {
                    x: window.innerWidth - 830,
                    ease: Quart.easeInOut,
                }, "-=1.75");
            } else {
                tl.set([this.el, wrapper, bg], {
                    x: 0
                });
                tl.set([this.el, wrapper], {
                    y:window.innerHeight
                })
                tl.to(bg, 1, {
                    y: '33%'
                });
                tl.to([this.el, wrapper], 1.5, {
                    y: 0,
                    delay: 0.25,
                    ease: Quart.easeInOut,
                }, '-=1');
            }
            return tl;
        },
        _timelineOut = function () {

            var tl = new gs.TimelineMax({
                    align: "start",
                    stagger: 0
                }),
                bg = document.getElementById('bg-container').querySelector('.bg:first-child'),
//                block = document.getElementById('intro-block'),
                wrapper = this.el.querySelector('.intro-wrapper'),
                ease = Quart.easeInOut,
                onWrapperComplete = function(){
                    this.el.style.display = "";
                };

            if (!document.body.classList.contains('mobile')) {
                tl.to(bg, 1, {
                    x: window.innerWidth,
                    ease: ease,
                    onComplete:function(){
                        bg.style.display = 'none';
                    }
                });
                tl.to(wrapper, 1, {
                    x: window.innerWidth,
                    ease: ease,
                    onComplete: _.bind(onWrapperComplete, this)
                }, '-=1');
            } else {
                
                tl.to(bg, 1, {
                    ease:ease,
                    y:window.innerHeight,
                    onComplete:function(){
                        bg.style.display = 'none';
                    }
                });
                tl.to(wrapper, 1, {
                    ease:ease,
                    y:window.innerHeight,
                    onComplete: _.bind(onWrapperComplete, this)
                }, '-=1')

            }

            return tl;

        };

    var IntroView = function () {
        AbstractView.call(this);
        this.el = document.getElementById('intro-block');

    };

    IntroView.prototype = _.assign({

        name: 'intro-view',

        _onresize: function () {
            var bg = document.getElementById('bg-container');
            if (!document.body.classList.contains('mobile')) {
                TweenMax.set(bg.querySelector('.bg:first-child'), {
                    x: window.innerWidth - 830,
                    y: '0%'
                });
            } else {
                TweenMax.set(bg.querySelector('.bg:first-child'), {
                    x: 0,
                    y: '33%'
                });

            }
            TweenMax.set(bg.querySelector('.bg:last-child'), {
                x: -window.innerWidth
            });
        },

        addEventListeners: function () {
            window.addEventListener('resize', this._onresize);
        },
        removeEventListeners: function () {
            window.removeEventListener('resize', this._onresize);
        },
    }, AbstractView.prototype, {
        playIn: function () {
            this.addEventListeners();
            var tl = _.bind(_timelineIn, this)();
            tl.play();

        },
        playOut: function () {
            this.removeEventListeners();
            var tl = _.bind(_timelineOut, this)();
            tl.play();



        }
    });

    module.exports = IntroView;

}());


/** WEBPACK FOOTER **
 ** ./holiday-map/intro.js
 **/